import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { SocialProof } from '../components/SocialProof';
import { PainPoints } from '../components/PainPoints';
import { Services } from '../components/Services';
import { WhyEducaLegalTeaser } from '../components/WhyEducaLegalTeaser';
import { FounderTeaser } from '../components/FounderTeaser';
import { Blog } from '../components/Blog';
import { LeadForm } from '../components/LeadForm';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
import { SEO } from '../seo/SEO';
import {
  organizationSchema,
  localBusinessSchema,
  personSchema,
  faqPageSchema,
} from '../seo/schemas';

export function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        canonical="/"
        schemas={[
          organizationSchema(),
          ...localBusinessSchema(),
          personSchema(),
          faqPageSchema(),
        ]}
      />
      <Header />
      <main>
        <Hero />
        <SocialProof />
        <PainPoints />
        <Services />
        <WhyEducaLegalTeaser />
        <FounderTeaser />
        <Blog />
        <LeadForm />
        <FAQ />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
